"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.processItem = void 0;
const core_1 = require("@veeam/core");
const types_1 = require("../types");
const getPropsFromDecorators_1 = require("./getPropsFromDecorators");
const decoratorProcessItem = (itemProps, payload, canAction) => {
    var _a;
    if (itemProps.type === types_1.TOOLBAR_ITEM_TYPE.button ||
        itemProps.type === types_1.TOOLBAR_ITEM_TYPE.customControl) {
        const { decorators = [], hasGuard, guardAction, resourceName, disabled, hidden } = itemProps;
        const notAllow = hasGuard
            ? !canAction(guardAction !== null && guardAction !== void 0 ? guardAction : core_1.ACTIONS.Write, resourceName || null)
            : false;
        const decoratedProps = (0, getPropsFromDecorators_1.getPropsFromDecorators)(decorators, payload || null, canAction);
        return Object.assign(Object.assign(Object.assign({}, itemProps), decoratedProps), { disabled: decoratedProps.disabled || notAllow || Boolean(disabled), hidden: decoratedProps.hidden || hidden });
    }
    if (itemProps.type === types_1.TOOLBAR_ITEM_TYPE.group) {
        const { disabled, hidden } = itemProps;
        const decoratedGroup = { disabled: true, hidden: true };
        const items = (_a = itemProps.items) === null || _a === void 0 ? void 0 : _a.reduce((acc, item) => {
            if (item && item.type !== types_1.TOOLBAR_ITEM_TYPE.separator) {
                const decoratedItem = decoratorProcessItem(item, payload, canAction);
                decoratedGroup.disabled = decoratedGroup.disabled && !!decoratedItem.disabled;
                decoratedGroup.hidden = decoratedGroup.hidden && !!decoratedItem.hidden;
                acc.push(decoratedItem);
            }
            else {
                acc.push(item);
            }
            return acc;
        }, []);
        return Object.assign(Object.assign({}, itemProps), { disabled: decoratedGroup.disabled || !!disabled, hidden: decoratedGroup.hidden || !!hidden, items });
    }
    return Object.assign({}, itemProps);
};
const processItem = (payload, _a, canAction) => {
    var { type, hidden } = _a, restProcessedItemProps = __rest(_a, ["type", "hidden"]);
    const _b = decoratorProcessItem(Object.assign({ type, hidden }, restProcessedItemProps), payload || null, canAction), { hidden: decoratedHidden } = _b, restDecoratedProps = __rest(_b, ["hidden"]);
    if (decoratedHidden) {
        return null;
    }
    return Object.assign(Object.assign({}, restDecoratedProps), { payload,
        type });
};
exports.processItem = processItem;
//# sourceMappingURL=processItem.js.map